export class SalesHistorySummary {
  private productSoldCount: number;
  private salesValueableCount: number;
  private salesSubsidyValueCount: number;
  private paymentrollValueCount: number;

  setProductSoldCount(value: number): void {
    this.productSoldCount = value;
  }

  getProductSoldCount(): number {
    return this.productSoldCount;
  }

  setSalesValueableCount(value: number): void {
    this.salesValueableCount = value;
  }

  getSalesValueableCount(): number {
    return this.salesValueableCount;
  }

  setSalesSubsidyValueCount(value: number): void {
    this.salesSubsidyValueCount = value;
  }

  getSalesSubsidyValueCount(): number {
    return this.salesSubsidyValueCount;
  }

  setPaymentrollValueCount(value: number): void {
    this.paymentrollValueCount = value;
  }

  getPaymentrollValueCount(): number {
    return this.paymentrollValueCount;
  }
}
